import { defaultSkinTextStyle, skinMap } from "@/pages/skin/js/skin-static";

export const skin = {
  namespaced: true,
  state: {
    skinData: JSON.parse(JSON.stringify(skinMap)),
    skinBackgrounds: [],
    skinElements: [],
    skinTextStyles: [],
  },
  mutations: {
    updateSkinData(state, map) {
      if (map.key !== undefined && map.data) {
        if (Array.isArray(map.data)) {
          map.data.splice(map.key, 1, map.value);
        } else {
          map.data[map.key] = map.value;
        }
        return;
      }
      Object.assign(state.skinData, map);
    },
    setSkinMaterials(state, { elements, backgrounds }) {
      state.skinBackgrounds = backgrounds || [];
      state.skinElements = elements || [];
    },
    setSkinTextStyles(state, textStyles) {
      state.skinTextStyles = textStyles || [];
      if (!state.skinData.textStyle.length) {
        state.skinData.textStyle = JSON.parse(JSON.stringify(defaultSkinTextStyle.styles));
      }
    },
    clearSkinCacheInfo(state) {
      state.skinData = JSON.parse(JSON.stringify(skinMap));
      state.skinBackgrounds = [];
      state.skinElements = [];
      state.skinTextStyles = [];
    },
  },
};
